import SVTAPI from './svtapi';

class MediaItem extends SVTAPI {
  /**
   * Initializes a new, existing media item.
   *
   * @param {number} pid The pid of the media item
   */
  constructor(pid) {
    super('/image');
    this._pid = pid;
  }

  /**
   * PATCH /image/:pid/weight
   * Sets an image's weight
   *
   * @param {number} weight - New weight value
   * @returns {object} - The server's response
   */
  setWeight(weight) {
    return super.patch({ url: '/' + this._pid + '/weight', data: { weight }});
  }

  /**
   * GET /image/:pid/history
   */

  getHistory() {
    return super.get({ url: '/' + this._pid + '/history' });
  }

  /**
   * POST /image/:pid/publish
   * POST /image/:pid/unpublish
   * Sets an image's publish state
   *
   * @param {boolean} state - Truthy to publish, falsey to unpublish
   * @returns {promise}
   */
  publish(state) {
    const endPoint = state ? '/publish' : '/unpublish';
    return super.post({ url: '/' + this._pid + endPoint });
  }

  /**
   * DELETE /image/:pid
   * Marks an image as deleted
   *
   * @returns {promise}
   */
  delete() {
    return super.remove({ url: '/' + this._pid });
  }

  /**
   * GET /image/:pid/restore-previous
   * Restores the previous, un-restored version of the MediaItem
   *
   * @returns {promise}
   */
  restorePrevious() {
    return super.get({ url: '/' + this._pid + '/restore-previous' });
  }
}

export default MediaItem;
